import type { RequestOptions } from '@mts-fe/types';
import type { AxiosRequestConfig } from 'axios';
import { replaceUrl, RequestMethod } from '@mts-fe/utils';
import { deviceInfo, SERVICE_PREFIX } from '@mts/utils';
import { defHttp } from '@mts/utils/http/axios';

/** 创建通用接口请求 */
export const createApi = <T extends Recordable, U = any>(
  url: string,
  method: RequestMethod = RequestMethod.POST,
  config?: AxiosRequestConfig,
  options?: RequestOptions,
) => {
  return async (params: T = {} as T) =>
    defHttp.request<U>(
      { ...config, method, url: params ? replaceUrl(url, params) : url, params },
      options,
    );
};

/** 获取当前吊挂站位信息 */
export const getStationInfo = () =>
  createApi(SERVICE_PREFIX.MPS + '/public/station/query', 'GET')(deviceInfo);
/** 设置当前吊挂站位信息 */
export const updateStationInfo = (params) =>
  createApi(SERVICE_PREFIX.MPS + '/public/station/bind')({ ...deviceInfo, ...params });

/** 获取当前样衣站位信息 */
export const getSampleStationInfo = () =>
  createApi(SERVICE_PREFIX.SGS + '/public/sample/device/binding/query')(deviceInfo);
/** 设置当前样衣站位信息 */
export const updateSampleStationInfo = (params) =>
  createApi(SERVICE_PREFIX.SGS + '/public/sample/device/binding')({
    ...deviceInfo,
    ...params,
  });

/** 获取当前工作站信息 */
export const getWorkStationInfo = () =>
  createApi(SERVICE_PREFIX.MP + '/public/configWorkStation/device/query')();
/** 设置当前工作站信息 */
export const updateWorkStationInfo = (params) =>
  createApi(SERVICE_PREFIX.MP + '/public/configWorkStation/device/bind')({
    ...deviceInfo,
    ...params,
  });

/** 获取当前分拣站信息 */
export const getSortStationInfo = () =>
  createApi(SERVICE_PREFIX.MPS + '/sort/bizStation/device/query', 'GET')(deviceInfo);
/** 设置当前分拣站信息 */
export const updateSortStationInfo = (params) =>
  createApi(SERVICE_PREFIX.MPS + '/sort/bizStation/device/bind')({
    ...deviceInfo,
    ...params,
  });

/** 分身绑定站位（重复调用即改绑；设备ID走全局 metas-device-id 请求头） */
export const bindAvatarStation = (params: { lineNo: string; stationNo: string }) =>
  createApi(SERVICE_PREFIX.MPS + '/station/avatar/bind')(params);
/** 解除分身绑定（幂等，无绑定记录时同样返回成功） */
export const unbindAvatarStation = () => createApi(SERVICE_PREFIX.MPS + '/station/avatar/unbind')();
